module.exports = __webpack_public_path__ + "img/hero_mobile_2.11167196.webp";